import {jarallax, jarallaxVideo} from 'jarallax';
//import 'jarallax/dist/jarallax.min.css';

export function initJarallax () {
    jarallax(document.querySelectorAll('.jarallax'), {
        //speed: 0.2,
        //type: 'scroll', //scroll, scale, opacity, scroll-opacity, scale-opacity
        /*disableParallax: function () {
            return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
        },*/
        disableVideo: function () {
            return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
        }
    });
}